/**
 * Returns the appropriate logo based on theme mode and environment configuration.
 * 
 * If REACT_APP_USE_LOGO is "true", uses {REACT_APP_CONFIG_STATE}-icon.png
 * Otherwise, defaults to IDEMIA-white (dark mode) / IDEMIA-purple (light mode)
 */

import idemiaWhite from '../assets/logo/IDEMIA-white.png';
import idemiaPurple from '../assets/logo/IDEMIA-purple.png';

const STATE = process.env.REACT_APP_CONFIG_STATE;
const USE_CUSTOM_LOGO = process.env.REACT_APP_USE_LOGO === 'true';

// Dynamically require the state logo if configured
let stateLogo: string | undefined;
if (USE_CUSTOM_LOGO && STATE) {
    try {
        stateLogo = require(`../assets/logo/${STATE}-icon.png`);
    } catch (e) {
        console.warn(`[getAppLogo] Custom logo "${STATE}-icon.png" not found, falling back to IDEMIA defaults`);
    }
}

export const getAppLogo = (isDark: boolean): string => {
    if (USE_CUSTOM_LOGO && stateLogo) {
        return stateLogo;
    }
    return isDark ? idemiaWhite : idemiaPurple;
};
